export const ToolbarTypes = {
   SET_SELECTED_SCREEN: "SET_SELECTED_SCREEN",
   UPDATE_SELECTED_SCREEN: "UPDATE_SELECTED_SCREEN",
};
